import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DraftDialog({
    openDraftDialog,
    setOpenDraftDialog,
    from,
    Deletedata,
    handleDeleteFileDraft,
    handleClose
}) {


    const handleOperation = () => {
        switch (from) {
            case "DraftAudio":
                Deletedata();
                break;
            case "DraftFile":
                handleDeleteFileDraft();
                break;
            default:
                break;
        }
    }

    return (
        <React.Fragment>
            <Dialog
                open={openDraftDialog}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure you want to delete it?"}</DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose} color='error' variant='contained'>Cancel</Button>
                    <Button onClick={handleOperation} color='primary' variant='contained'>Confirm</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}